import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.Diner;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "Diner.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "Diner.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "Diner.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/DinerGame/scenes/IntroductionScene.ts